import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltroEstoqueComponent } from './filtro-estoque.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [FiltroEstoqueComponent],
  imports: [
    CommonModule, SharedModule, ReactiveFormsModule
  ]
})
export class FiltroEstoqueModule { }
